import { BottomMenuItem } from "Components/Layout/Menu/BottomMenuItem";
import { useBottomMenu } from "Hooks/Layout/useBottomMenu";
import { useCurrentUserRole } from "Hooks/useCurrentUserAccessRole";
import { useNavigate } from "Navigation/useNavigate";
import { Resources, useResource } from "Translations/Resources";
import type { AccessRoleCode } from "Models/AccessRoleCodes";
import { useLocation } from "react-router";
import { useCurrentUserHomepage } from "Hooks/useCurrentUserHomepage";
import { Box, type SxProps } from "@mui/material";
import { BottomNavigation } from "@mui/material";

export const BOTTOM_MENU_HEIGHT = "61px";

const getNavigationStyles = (itemsCount: number): SxProps => ({
  display: "grid",
  gridTemplateColumns: `repeat(${itemsCount}, minmax(70px, 1fr))`,
  justifyItems: "center",
  maxWidth: "500px",
  width: "100%",
  padding: "4px 8px 12px 8px",
  height: BOTTOM_MENU_HEIGHT,
});

type UserRoleMenuProps = { userRole: AccessRoleCode };

const UserRoleMenu = ({ userRole }: UserRoleMenuProps) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const menuLinks = useBottomMenu(userRole);
  const { homepageUrl } = useCurrentUserHomepage();

  // Normalize "/" to the user's role-specific homepage for active state detection
  const normalizedPathname =
    pathname === "/" && homepageUrl ? homepageUrl : pathname;

  return (
    <Box
      sx={{
        width: "100%",
        position: "fixed",
        bottom: 0,
        zIndex: 2,
        backgroundColor: "common.white",
        boxShadow: "0px -1px 4px rgba(0, 0, 0, 0.05)",
      }}
      height={BOTTOM_MENU_HEIGHT}
      display="flex"
      justifyContent="center"
      width="100%"
    >
      <BottomNavigation
        showLabels
        value={normalizedPathname}
        onChange={(_, value) =>
          navigate(value, { replace: true, resetHistory: true })
        }
        sx={getNavigationStyles(menuLinks.length)}
      >
        {menuLinks.map((link) => (
          <BottomMenuItem key={link.value} {...link} />
        ))}
      </BottomNavigation>
    </Box>
  );
};

export const BottomMenu = () => {
  const userRole = useCurrentUserRole();
  const { t } = useResource();

  if (!userRole) {
    return <>{t(Resources.Errors.NoUserRole)}</>;
  }

  return <UserRoleMenu userRole={userRole} />;
};
